enum BusinessTimeEstablishedType {
  NotSet = 0,
  LessThanOneYear = 1,
  OneYear = 2,
  TwoYears = 3,
  ThreeYears = 4,
  FourYears = 5,
  FiveOrMoreYears = 6
}

export default BusinessTimeEstablishedType;
